import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b55a17f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "milestone-displayer" }
const _hoisted_2 = ["onMouseenter"]
const _hoisted_3 = { class: "flex items-start gap-3 mb-8 justify-between" }
const _hoisted_4 = { class: "title-container" }
const _hoisted_5 = { class: "icon-container" }
const _hoisted_6 = { class: "material-icons icon text-[var(--text-color)]" }
const _hoisted_7 = { class: "text-4xl mb-0 text-[var(--text-color)]" }
const _hoisted_8 = {
  key: 0,
  class: "user-container text-2xl"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 cursor-pointer :hover:text-red-500" }, "Sil", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "user-container text-2xl"
}
const _hoisted_13 = {
  key: 0,
  class: "text-2xl mb-3"
}
const _hoisted_14 = {
  key: 1,
  class: "documents-section mt-6"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-2xl font-semibold mb-4 text-[var(--text-color)]" }, "Yüklenen Dosyalar", -1))
const _hoisted_16 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_17 = {
  key: 0,
  class: "milestone-connector"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "connector-arrow" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "connector-line" }, null, -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

import type { AcMilestone } from '~/types/crm';
import { formatDate } from '@/mixins/visualFormatters';
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import AccaFileDisplayer from '@/components/reusable/accaFileDisplayer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'milestoneDisplayer',
  props: {
    milestones: {},
    iconSize: {}
  },
  emits: ["deleteMilestone"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "6b193ae5": (_ctx.iconSize)
}))

const emits = __emit

const store = useStore()
const userProfile = computed(() => store.getters['user/userProfile'])
const hoveredMilestone = ref<number | null>(null)

const emitDeleteMilestone = (milestone: AcMilestone) => {
    emits("deleteMilestone", milestone)
}



const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.milestones.slice().reverse(), (milestone, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: milestone.id || milestone.date.toString(),
        class: "milestone-section"
      }, [
        _createElementVNode("div", {
          class: "milestone-item border border-gray-500 rounded-xl p-6",
          onMouseenter: ($event: any) => (hoveredMilestone.value = index),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoveredMilestone.value = null))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(milestone.icon), 1)
              ]),
              _createElementVNode("h3", _hoisted_7, _toDisplayString(milestone.title), 1)
            ]),
            (milestone.user.id === userProfile.value?.uid && hoveredMilestone.value === index)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (emitDeleteMilestone(milestone)),
                    class: "ac-minimal-button"
                  }, _hoisted_11, 8, _hoisted_9)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("p", null, _toDisplayString(milestone.user.userName), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(formatDate)(milestone.date.toDate())), 1)
                ]))
          ]),
          (milestone.explanation)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(milestone.explanation), 1))
            : _createCommentVNode("", true),
          (milestone.documents && milestone.documents.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(milestone.documents, (document) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: document.url,
                      class: "document-item p-3 border border-gray-300 rounded-lg bg-gray-50"
                    }, [
                      _createVNode(AccaFileDisplayer, { file: document }, null, 8, ["file"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 40, _hoisted_2),
        (index < props.milestones.slice().reverse().length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})